/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  document.addEventListener("DOMContentLoaded", function () {
    // DESKTOP: aggiungi la classe solo dove la voce è "BRAND"
    document.querySelectorAll(".menu__item.parent").forEach(function (parent) {
      const label = parent.querySelector(".navlink--toplevel .navtext");
      if (label && label.textContent.trim().toUpperCase().includes("BRAND")) {
        parent.classList.add("menu__item--brand");
      }
    });

    // MOBILE: aggiungi la classe solo ai LI livello 1 dove il testo è BRAND
    document
      .querySelectorAll("li.mobile-menu__item--level-1")
      .forEach(function (li) {
        // cerca il link principale di livello 1
        var link = li.querySelector(".mobile-navlink--level-1");
        if (link && link.textContent.trim().toUpperCase().includes("BRAND")) {
          li.classList.add("mobile-menu__item--brand");
        }
      });

    // Rimuovi il parametro lshst=collection dagli URL dei link dei prodotti
    function removeLshstParam(url) {
      if (!url) return url;
      try {
        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.delete('lshst');
        return urlObj.pathname + urlObj.search + urlObj.hash;
      } catch (e) {
        // Se l'URL non è valido, rimuovi il parametro manualmente
        return url.replace(/[?&]lshst=[^&]*/g, '').replace(/[?&]$/, '');
      }
    }

    // Rimuovi il parametro dai link dei prodotti quando vengono cliccati
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a[href*="/products/"]');
      if (link && link.hasAttribute('data-grid-link')) {
        const originalHref = link.getAttribute('href');
        if (originalHref && originalHref.includes('lshst=')) {
          const cleanHref = removeLshstParam(originalHref);
          link.setAttribute('href', cleanHref);
        }
      }
    }, true);

    // Rimuovi il parametro dall'URL corrente se presente
    if (window.location.search.includes('lshst=')) {
      const cleanUrl = removeLshstParam(window.location.href);
      if (cleanUrl !== window.location.pathname + window.location.search + window.location.hash) {
        window.history.replaceState({}, '', cleanUrl);
      }
    }

    // Guida alle taglie: converti paragrafi " · " in tabelle responsive
    document.querySelectorAll(".accordions-section .accordion__text.rte, .section-accordions .accordion__text.rte").forEach(function (rte) {
      var paragraphs = Array.from(rte.querySelectorAll(":scope > p"));
      var sep = " · ";
      var minCols = 5;
      function getCells(text) {
        return text.split(sep).map(function (s) { return s.trim(); });
      }
      function hasTableShape(p) {
        var text = (p.textContent || "").trim();
        var parts = text.split(sep);
        return parts.length >= minCols;
      }
      var headerIndex = paragraphs.findIndex(hasTableShape);
      if (headerIndex === -1) return;
      var headerP = paragraphs[headerIndex];
      var dataParagraphs = [];
      for (var i = headerIndex + 1; i < paragraphs.length; i++) {
        if (!hasTableShape(paragraphs[i])) break;
        dataParagraphs.push(paragraphs[i]);
      }
      if (dataParagraphs.length === 0) return;
      var headerCells = getCells(headerP.textContent);
      var wrapper = document.createElement("div");
      wrapper.className = "size-guide-table-wrap";
      var table = document.createElement("table");
      table.className = "size-guide-table";
      var thead = document.createElement("thead");
      var headerRow = document.createElement("tr");
      headerCells.forEach(function (cell) {
        var th = document.createElement("th");
        th.textContent = cell;
        headerRow.appendChild(th);
      });
      thead.appendChild(headerRow);
      table.appendChild(thead);
      var tbody = document.createElement("tbody");
      dataParagraphs.forEach(function (p) {
        var tr = document.createElement("tr");
        getCells(p.textContent).forEach(function (cell, i) {
          var td = document.createElement("td");
          td.textContent = cell;
          if (headerCells[i]) td.setAttribute("data-label", headerCells[i]);
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      wrapper.appendChild(table);
      rte.insertBefore(wrapper, headerP);
      headerP.remove();
      dataParagraphs.forEach(function (p) { p.remove(); });
    });

    // Guida alle taglie: carica contenuto pagina nel drawer quando è vuoto
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-drawer-toggle][aria-controls^=\"size-chart\"]");
      if (!btn) return;
      var drawerId = btn.getAttribute("aria-controls");
      var drawer = drawerId ? document.getElementById(drawerId) : null;
      if (!drawer) return;
      var fetchEl = drawer.querySelector(".size-chart-drawer__fetch[data-fetch-url]");
      if (!fetchEl) return;
      var url = fetchEl.getAttribute("data-fetch-url");
      if (!url) return;
      var fullUrl = url.indexOf("http") === 0 ? url : (window.location.origin + (url.indexOf("/") === 0 ? url : "/" + url));
      fetchEl.removeAttribute("data-fetch-url");
      function showFallback() {
        fetchEl.innerHTML = "<p class=\"size-chart-drawer__fallback\">Impossibile caricare la guida. <a href=\"" + fullUrl + "\">Apri la guida alle taglie</a>.</p>";
      }
      fetch(fullUrl, { cache: "no-store" })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var main = doc.querySelector("#MainContent") || doc.querySelector("main") || doc.querySelector(".main-content") || doc.body;
          if (!main) {
            showFallback();
            fetchEl.classList.remove("size-chart-drawer__fetch");
            fetchEl.removeAttribute("data-loading");
            return;
          }
          var inner = (main.innerHTML || "").trim();
          if (inner.length < 50) {
            var sections = main.querySelectorAll(".shopify-section .section-text, .shopify-section .section-accordions");
            if (sections.length) {
              var wrap = document.createElement("div");
              sections.forEach(function (s) { wrap.appendChild(s.cloneNode(true)); });
              inner = wrap.innerHTML;
            }
          }
          if (inner.length < 50) {
            showFallback();
          } else {
            fetchEl.classList.add("size-chart-drawer__content");
            fetchEl.innerHTML = inner;
            var rtes = fetchEl.querySelectorAll(".accordion__text.rte");
            rtes.forEach(function (rte) {
              var paragraphs = Array.from(rte.querySelectorAll(":scope > p"));
              var sep = " · ";
              var minCols = 5;
              function getCells(text) { return text.split(sep).map(function (s) { return s.trim(); }); }
              function hasTableShape(p) { var text = (p.textContent || "").trim(); return text.split(sep).length >= minCols; }
              var headerIndex = paragraphs.findIndex(hasTableShape);
              if (headerIndex === -1) return;
              var headerP = paragraphs[headerIndex];
              var dataParagraphs = [];
              for (var i = headerIndex + 1; i < paragraphs.length; i++) { if (!hasTableShape(paragraphs[i])) break; dataParagraphs.push(paragraphs[i]); }
              if (dataParagraphs.length === 0) return;
              var headerCells = getCells(headerP.textContent);
              var wrapper = document.createElement("div"); wrapper.className = "size-guide-table-wrap";
              var table = document.createElement("table"); table.className = "size-guide-table";
              var thead = document.createElement("thead"); var headerRow = document.createElement("tr");
              headerCells.forEach(function (cell) { var th = document.createElement("th"); th.textContent = cell; headerRow.appendChild(th); });
              thead.appendChild(headerRow); table.appendChild(thead);
              var tbody = document.createElement("tbody");
              dataParagraphs.forEach(function (p) {
                var tr = document.createElement("tr");
                getCells(p.textContent).forEach(function (cell, i) { var td = document.createElement("td"); td.textContent = cell; if (headerCells[i]) td.setAttribute("data-label", headerCells[i]); tr.appendChild(td); });
                tbody.appendChild(tr);
              });
              table.appendChild(tbody); wrapper.appendChild(table);
              rte.insertBefore(wrapper, headerP); headerP.remove();
              dataParagraphs.forEach(function (p) { p.remove(); });
            });
          }
          fetchEl.classList.remove("size-chart-drawer__fetch");
          fetchEl.removeAttribute("data-loading");
        })
        .catch(function () {
          showFallback();
          fetchEl.classList.remove("size-chart-drawer__fetch");
          fetchEl.removeAttribute("data-loading");
        });
    });
  });
})();
